module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e06-54c0f66e3cb8bf89524e6ef21765f9cc.jpg";